import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { $ } from "react-jquery-plugin";
import AuthService from "../../../api/services/AuthService";
import { alertErrorMessage } from "../../../customComponents/CustomAlertMessage";
import "../SignupPage/signup-wizard.css";

const RegistrationResult = () => {
  const { authenticationToken } = useParams();
  const navigate = useNavigate();
  const [verification, setVerification] = useState("");
  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    $("body").addClass("signupbg");
    document.body.classList.add("signup-wizard-full-steps");
    return () => {
      $("body").removeClass("signupbg");
      document.body.classList.remove("signup-wizard-full-steps");
    };
  }, []);

  useEffect(() => {
    if (!authenticationToken) return;
    (async () => {
      try {
        const result = await AuthService.verifyRegistrationToken(authenticationToken);
        if (result?.success) {
          if (result?.accountStatus === "Inactive") {
            alertErrorMessage("Please verify your account");
            navigate("/login");
            return;
          }
          setVerification(result?.accountStatus);
        } else {
          if (result?.accountStatus === "Blocked") {
            setVerification(result?.accountStatus);
          } else {
            alertErrorMessage(result?.message || "Please verify your account");
            navigate("/login");
          }
        }
      } catch (err) {
        alertErrorMessage(err?.message);
        navigate("/login");
      } finally {
        setLoading(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    })();
  }, [authenticationToken, navigate]);

  return (
    <>
      <Helmet>
        <title>Account Status – AGCX</title>
      </Helmet>

      <div className="login_fullhieght" style={{ display: "flex", flexDirection: "column", flex: "1 1 auto", minHeight: "calc(100vh - 58px)" }}>
        <div className="sign_in_form_s signup-step-centered" style={{ gridTemplateColumns: "1fr" }}>
          <div className="login_section bgsignup">
            <div className="login_form_right signup-wizard-welcome-wide">
              <div className="form_block_login" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center" }}>
                <div className="tab-content">
                  <div className="tab-pane fade show active" role="tabpanel">
                    <div className="row">
                      {loading ? (
                        <div className="col-sm-12 input_block text-center">
                          <p className="signup-wizard-subtitle">Checking account status…</p>
                        </div>
                      ) : verification === "Active" ? (
                        <>
                          <div className="col-sm-12 input_block text-center">
                            <div className="signup-wizard-welcome-img">
                              <img src="/images/login_sucessfull_img.svg" alt="" />
                            </div>
                            <h3 className="mb-2 verify_hd">
                              Your account is <span>active</span>!
                            </h3>
                            <p className="signup-wizard-subtitle">
                              Your account has been successfully activated. You can now log in and start trading.
                            </p>
                          </div>
                          <div className="col-sm-12 login_btn">
                            <button type="button" className="next_btn" onClick={() => navigate("/login")}>
                              Log In
                            </button>
                          </div>
                        </>
                      ) : verification === "Blocked" ? (
                        <>
                          <div className="col-sm-12 input_block text-center">
                            <div className="signup-wizard-welcome-img">
                           
                            </div>
                            <h3 className="mb-2 verify_hd">
                              Account <span>suspended</span>
                            </h3>
                            <p className="signup-wizard-subtitle">
                              Your account has been temporarily suspended due to too many incorrect verification attempts.
                            </p>
                            <p className="signup-wizard-subtitle">
                              If you believe this is a mistake, please contact our support team at{" "}
                              <a href="mailto:support@agcx.com">support@agcx.com</a>.
                            </p>
                          </div>
                          <div className="col-sm-12">
                            <div className="signup-wizard-secure">
                              <img src="/images/secure_icon.svg" alt="secure" />
                              Your information is securely encrypted on AGCX.
                            </div>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegistrationResult;
